import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ─── AVAILABILITY MANAGEMENT ──────────────────────────────────────────────────

// GET api/AvailabilityManagement/GetAvailabilityManagementTables
// → AvailabilityManagementDto { availabilityTable, blendedTable, pairedCitiesTable }
export const AvailabilityManagementGetTablesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}AvailabilityManagement/GetAvailabilityManagementTables`,
	hasLoading: false,
});

// PUT api/AvailabilityManagement/UpdateAvailabilityRevised?userId=...
// body → AvailabilityRevisedUpdateDto
export const AvailabilityManagementUpdateRevisedRequest = (userId, dto) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}AvailabilityManagement/UpdateAvailabilityRevised`,
	params: { userId },
	data: dto,
	hasLoading: true,
});
